"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickRandomRace = void 0;
const domain_1 = require("../domain");
function randomEnum(anEnum) {
    const enumValues = Object.values(anEnum);
    const randomIndex = Math.floor(Math.random() * enumValues.length);
    return enumValues[randomIndex];
}
const pickRandomRace = () => {
    return randomEnum(domain_1.Race);
};
exports.pickRandomRace = pickRandomRace;
//# sourceMappingURL=pickRandomRace.js.map